"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const throttle_1 = __importDefault(require("lodash/throttle"));
require("./infiniteScroll.scss");
const infiniteLoader_1 = __importDefault(require("../infiniteLoader/infiniteLoader"));
class InfiniteScroll extends react_1.default.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false
        };
        this.Ref = react_1.createRef();
        this.check = throttle_1.default(this.check.bind(this), props.throttle);
    }
    check() {
        const { isLoading, hasMore, threshold, onLoadMore } = this.props;
        this.setState({ loading: isLoading });
        if (isLoading || !hasMore) {
            return;
        }
        const sentinel = this.Ref.current;
        const fromBottom = sentinel.getBoundingClientRect().top - window.innerHeight;
        if (fromBottom < threshold) {
            onLoadMore();
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.check);
        window.addEventListener('resize', this.check);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.check);
        window.removeEventListener('resize', this.check);
    }
    render() {
        const { children } = this.props;
        const { loading } = this.state;
        return (react_1.default.createElement("div", null,
            children,
            loading && react_1.default.createElement("div", { className: 'loader-wrapper' },
                react_1.default.createElement(infiniteLoader_1.default, null)),
            react_1.default.createElement("div", { ref: this.Ref })));
    }
}
InfiniteScroll.defaultProps = {
    threshold: 100,
    throttle: 64
};
exports.default = InfiniteScroll;
